import { render, staticRenderFns } from "./MasterStockist.vue?vue&type=template&id=4d173f12&"
import script from "./MasterStockist.vue?vue&type=script&lang=js&"
export * from "./MasterStockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports